module.exports = __webpack_public_path__ + "img/ster.9f97585b1cb0d8bf0b9c4001f10ecc01.svg";